<template>
    <a class="checkbox" @click="onClick" v-bind:class="{ checked: isChecked }">
        <div class="checkmark"></div>
        <div class="checklabel">{{ label }}</div>
    </a>
</template>

<script>
export default {
    name: 'Checkbox',
    props: [
        "id",
        "name",
        "label",
        "checked",
        "value"
    ],
    data() {
        return {
            isChecked: false
        }
    },
    methods: {
        onClick: function (e) {
            this.isChecked = !this.isChecked;
            this.$emit("change", { id: this.id, name: this.name, label: this.label, checked: this.isChecked, value: this.value });
        }
    },
    watch: {
        checked() {
            this.isChecked = this.checked || false;
        }
    },
    mounted() {
        this.isChecked = this.checked || false;
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.checkbox {
    display: flex;
    align-items: center;
    cursor: pointer;
    color: black;
    font-weight: 400;
    margin-bottom: 5px;
    max-width: calc(100% - 40px);
}

.checkbox .checkmark {
    width: 24px;
    min-width: 24px;
    height: 24px;
    border: 1px solid #323232;
    background-color: white;
    margin-right: 8px;
}

.checkbox.checked .checkmark {
    background-image: url("data:image/svg+xml,%3Csvg width='17' height='13' viewBox='0 0 17 13' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0.949219 5.27148L6.44922 10.7715L15.9492 1.27148' stroke='white' stroke-width='2'/%3E%3C/svg%3E%0A");
    background-size: 17px;
    background-repeat: no-repeat;
    background-position: 50%;
    background-color: #2655ff;
    border: none;
}

.checkbox .checklabel {
    font-family: "Gotham SSm A", Arial, Helvetica, sans-serif;
    font-size: 14px;
    font-weight: 500;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

.checkbox>input[type=checkbox] {
    display: none;
}
</style>